import { TriangleAlertIcon } from 'components/icons/TriangleAlert'
import { PageTitle } from 'components/PageTitle'
import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'

export const SectionEndedPage = observer(function SectionEndedPage() {
  const { tt } = useTranslationTyped()

  return (
    <main
      data-testid="lti-section-ended-page"
      className="flex h-full w-full flex-col bg-surface-bright p-10"
    >
      <PageTitle title={tt.lti.page_title()} />
      <div className="flex flex-1 flex-col items-center justify-center rounded-2xl border border-outline-medium bg-core-on-primary">
        <div className="mb-4">
          <TriangleAlertIcon className="stroke-core-error" size={30} />
        </div>
        <div className="flex flex-col gap-1 text-center">
          <h1 className="text-title-large text-core-primary">
            {tt.lti.section_ended.title()}
          </h1>
          <p className="text-body-large text-on-surface-var">
            {tt.lti.section_ended.description()}
          </p>
        </div>
      </div>
    </main>
  )
})
